module.exports = __webpack_public_path__ + "img/distribute04.a01bd940.png";